// Video Gallery Modal Handler
class VideoGalleryModal {
    constructor() {
        this.modal = document.getElementById('cf-video-modal');
        this.modalVideo = document.getElementById('cf-modal-video');
        this.modalClose = document.querySelector('.cf-video-modal-close');
        this.modalOverlay = document.querySelector('.cf-video-modal-overlay');
        this.thumbnails = document.querySelectorAll('.cf-video-thumbnail-card');
        
        if (!this.modal || !this.modalVideo || this.thumbnails.length === 0) {
            console.log('Video gallery elements not found');
            return;
        }
        
        this.init();
    }
    
    init() {
        console.log('Initializing video gallery with', this.thumbnails.length, 'thumbnails');
        
        // Add click handlers to thumbnails
        this.thumbnails.forEach(thumbnail => {
            // Make thumbnails keyboard accessible
            thumbnail.style.cursor = 'pointer';
            
            thumbnail.addEventListener('click', (e) => {
                e.preventDefault();
                const sources = thumbnail.getAttribute('data-video-sources');
                console.log('Thumbnail clicked, sources:', sources);
                this.openModal(sources);
            });
            
            // Keyboard accessibility
            thumbnail.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    const sources = thumbnail.getAttribute('data-video-sources');
                    this.openModal(sources);
                }
            });
        });
        
        // Close modal handlers
        if (this.modalClose) {
            this.modalClose.addEventListener('click', () => this.closeModal());
        }
        
        if (this.modalOverlay) {
            this.modalOverlay.addEventListener('click', () => this.closeModal());
        }
        
        // ESC key to close
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.modal.classList.contains('is-active')) {
                this.closeModal();
            }
        });
    }
    
    openModal(sources) {
        if (!sources) {
            console.error('No video sources provided');
            return;
        }
        
        try {
            // Clear existing sources
            this.modalVideo.innerHTML = '';
            
            // Handle different formats of sources
            let sourcesArray;
            
            // Try to parse JSON if it's a string
            if (typeof sources === 'string') {
                // Unescape HTML entities if needed
                sources = sources.replace(/&quot;/g, '"')
                                 .replace(/&#39;/g, "'")
                                 .replace(/&lt;/g, '<')
                                 .replace(/&gt;/g, '>')
                                 .replace(/&amp;/g, '&');
                
                sourcesArray = JSON.parse(sources);
            } else {
                sourcesArray = sources;
            }
            
            // Add new sources
            sourcesArray.forEach(source => {
                const sourceElement = document.createElement('source');
                sourceElement.src = source.url;
                sourceElement.type = source.mime_type;
                this.modalVideo.appendChild(sourceElement);
            });
            
            // Show modal
            this.modal.classList.add('is-active');
            this.modal.setAttribute('aria-hidden', 'false');
            document.body.style.overflow = 'hidden';
            
            // Load and play video
            this.modalVideo.load();
            this.modalVideo.play().catch(e => console.log('Autoplay prevented:', e));
            
        } catch (error) {
            console.error('Error opening video modal:', error);
            console.error('Sources string:', sources);
        }
    }
    
    closeModal() {
        this.modal.classList.remove('is-active');
        this.modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        
        // Pause and reset video
        this.modalVideo.pause();
        this.modalVideo.currentTime = 0;
    }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        new VideoGalleryModal();
    });
} else {
    // DOM is already loaded
    new VideoGalleryModal();
}

// Also initialize when Shopify section is reloaded (theme editor)
document.addEventListener('shopify:section:load', () => {
    new VideoGalleryModal();
});